import { downloadTemplate } from './excelUtils';

const INVENTORY_IMPORT_COLUMNS = [
  { header: 'Item Type',          example: 'wine' },
  { header: 'Item Name',          example: 'Château Margaux 2018' },
  { header: 'Size Value',         example: '750' },
  { header: 'Size Unit',          example: 'ml' },
  { header: 'Active',             example: 'true' },
  { header: 'Bin Location',       example: 'A3' },
  { header: 'Par Level',          example: '6' },
  { header: 'Reorder Point',      example: '2' },
  { header: 'Location',           example: 'Main Cellar' },
  { header: 'Supplier Name',      example: 'Berry Bros & Rudd' },
  { header: 'Supplier Item Code', example: 'BBR-12345' },
  { header: 'Cost',               example: '45.00' },
  { header: 'Wine List Name',     example: 'Main Wine List' },
  { header: 'Selling Price',      example: '95.00' },
];

export const INVENTORY_IMPORT_HEADERS = INVENTORY_IMPORT_COLUMNS.map(c => c.header);

export function downloadInventoryImportTemplate(): void {
  downloadTemplate('inventory-import', INVENTORY_IMPORT_COLUMNS);
}
